import * as React from 'react'
import { ProductCardSkeleton, Carousel } from '@lacedltd/laced-components'
import { withTranslations } from 'helpers'
import { ProductCardProduct } from '../../types/product'
import ProductRowItem from '../ProductRowItem/ProductRowItem'
import * as S from './ProductRow.styles'

const ProductRow: React.FC<CarouselProps> = ({
  title,
  products = [],
  loading
}) => {
  return (
    <S.ProductRowWrapper aria-label={`Carousel-${title}`}>
      {loading && !products.length ? (
        <Carousel key="LoadingCarousel" title={title}>
          {new Array(6).fill(null).map((index) => (
            <ProductCardSkeleton key={index} />
          ))}
        </Carousel>
      ) : (
        <Carousel key="ProductCardCarousel" title={title}>
          {products.map((product) => (
            <ProductRowItem key={product.title} product={product} />
          ))}
        </Carousel>
      )}
    </S.ProductRowWrapper>
  )
}

interface CarouselProps {
  products?: ProductCardProduct[] | []
  title: string
  loading: boolean
}

export default withTranslations(ProductRow)
